<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>組織・所属新規作成</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info" v-on:click="back">キャンセルする</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="register">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>組織名</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="100" v-model="organization.organizationName" class="form-control" placeholder="組織名（必須）" required>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>階層</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="organization.hierarchyNo" v-on:change="selectHierarchy">
                  <option value="0">Top</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>親組織</label>
              </div>
              <div class="col-9">
                <select class="form-control" v-model="organization.parentId" :required="parentRequired">
                  <option v-for="option in organizationOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.organizationName }}
                  </option>
                </select>
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>同一階層内表示順</label>
              </div>
              <div class="col-2">
                <input type="number" v-model="organization.belongsOrder" class="form-control" required>
              </div>
              <div class="col-7">
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ユーザー所属</label>
              </div>
              <div class="col-2">
                <input type="checkbox" class="form-control" v-model="organization.isBelongs">
              </div>
              <div class="col-7">
              </div>
            </div>  
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>表示名</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="100" v-bind:readonly="!organization.isBelongs" v-model="organization.displayName" class="form-control" placeholder="表示名" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>プロフィール表示</label>
              </div>
              <div class="col-2">
                <input type="checkbox" v-bind:disabled="!organization.isBelongs" class="form-control" v-model="organization.isDisplayed">
              </div>
              <div class="col-7">
              </div>
            </div>  
          </div>
          <button id="register_button" type="submit" class="btn btn-info btn btn-block">登録する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'OrgCreate',
  mixins: [sessions,path,headers],
  props: ['realms'],  
  data: function(){
    return {
      message: '',
      organizationOptions: [],
      parentRequired: false,
      organization: {
        hospitalId: '',
        organizationName: '',
        hierarchyNo: 0,
        parentId: 0,
        belongsOrder: 1,
        isBelongs: false,
        displayName: '',
        isDisplayed: true,
        historyId: '',
      }
    }
  },
  computed: {
    isMessage: function () {
      return this.message.length > 0
    }
  },
  methods: {
    register() {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var reserveId = this.$route.params.reserveid;
          this.organization.hospitalId = hospitalId
          this.organization.historyId = reserveId
          axios.post("/api/organization", {
              organization: this.organization
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('登録されました。');
              this.back()
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
        this.message = err.message
      })
    },
    back() {
      var reserveId = this.$route.params.reserveid;
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/reserve/orglist/'+reserveId))
    },
    selectHierarchy() {
      this.getHierarchylist(this.organization.hierarchyNo - 1)
    },
    getHierarchylist(hierarchyNo) {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          var reserveId = this.$route.params.reserveid
          axios.post("/api/organization/management/hierarchylist",{
            hospitalId: hospitalId,
            historyId: reserveId,
            hierarchyNo: hierarchyNo,
           },{
            headers: this.headers(accessToken)
          }).then(response => {
            this.organizationOptions = response.data.data.organizations
            if(this.organizationOptions.length > 0) {
              var selected = this.organizationOptions[0]
              this.organization.parentId = selected.id
              this.parentRequired = true
            } else if (Number(this.organization.hierarchyNo) === 0) {
              this.organization.parentId = 0
              this.parentRequired = false
            } else {
              this.organization.parentId = null
              this.parentRequired = true
            }
          }).catch(err => {
            throw err
          })
      } else {
        //this.$router.replace('/login') 
      }}).catch((err) => {
        this.message = err.message
      })
    },
  } 
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#backBtn {
  float:right;
}
#register_button {
  margin-top: 30px;
}
</style>